import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const AccordianDownIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1.33594L6 6.89149L11 1.33594"
      stroke="#EEF7FF"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default AccordianDownIconDark;
